import { FC } from 'react';

import Button, { ButtonScale, ButtonKind, ButtonAppearance } from 'bloko/blocks/button';
import InfoInline from 'bloko/blocks/drop/InfoInline';
import HSpacingContainer from 'bloko/blocks/hSpacing/HSpacingContainer';
import Modal, { ModalContent } from 'bloko/blocks/modal';
import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import { useOnOffState } from 'src/hooks/useOnOffState';
import { useSelector } from 'src/hooks/useSelector';

import {
    AngaraKeys,
    COLUMN_FOR_ANGARA,
    downloadCSV,
    generateAngaraCSV,
    TRLS_HEADERS_FOR_ANGARA,
} from 'src/components/Debug/SearchExplanation/utils';

import styles from './styles.less';

// Компонент для DS из поиска
const SearchExplanation: FC = () => {
    const resumeHash = useSelector((state) => state.router.location.query?.resume);
    const explanation = useSelector((state) => state.searchExplanation);

    const [isVisible, setVisible, resetVisible] = useOnOffState(false);

    if (!explanation) {
        return null;
    }

    const fileNameForAngara = `serp_explanation_${resumeHash}`;

    return (
        <>
            <VSpacing base={4} />
            <InfoInline
                show
                showCloseButton={false}
                noIndent
                render={() => (
                    <div className={styles.searchExplanationContainer}>
                        <Text strong>Angara Search Explanation</Text>
                        <HSpacingContainer base={2}>
                            <Button
                                scale={ButtonScale.Small}
                                kind={ButtonKind.Primary}
                                appearance={ButtonAppearance.Outlined}
                                onClick={() => {
                                    const csv = generateAngaraCSV(explanation);
                                    downloadCSV(fileNameForAngara, csv);
                                }}
                            >
                                Download CSV
                            </Button>
                            <Button
                                scale={ButtonScale.Small}
                                kind={ButtonKind.Primary}
                                appearance={ButtonAppearance.Outlined}
                                onClick={setVisible}
                            >
                                Show table
                            </Button>
                        </HSpacingContainer>
                    </div>
                )}
            />
            <Modal visible={isVisible} onClose={resetVisible}>
                <ModalContent>
                    <div className={styles.searchExplanationTableContainer}>
                        <table>
                            <thead>
                                <tr>
                                    {COLUMN_FOR_ANGARA.map((column) => (
                                        <th className={styles.searchExplanationTableCell} key={column}>
                                            <Text strong>{TRLS_HEADERS_FOR_ANGARA[column]}</Text>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {explanation.map((item) => (
                                    <tr key={item[AngaraKeys.VacancyName]}>
                                        {COLUMN_FOR_ANGARA.map((column) => (
                                            <td className={styles.searchExplanationTableCell} key={column}>
                                                {item[column]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </ModalContent>
            </Modal>
        </>
    );
};

export default SearchExplanation;
